<script lang="ts">
  let {
    pageTitle = 'Design',
    dirty = false,
    saving = false,
    enhancing = false,
    canUndo = false,
    canRedo = false,
    onEnhance = () => {},
    onUndo = () => {},
    onRedo = () => {},
    onSave = () => {},
  }: {
    pageTitle?: string;
    dirty?: boolean;
    saving?: boolean;
    enhancing?: boolean;
    canUndo?: boolean;
    canRedo?: boolean;
    onEnhance?: () => void;
    onUndo?: () => void;
    onRedo?: () => void;
    onSave?: () => void;
  } = $props();
</script>

<div class="sticky top-0 z-20 overflow-hidden rounded-[1.75rem] border border-default bg-white/90 dark:bg-dark-secondary/90 backdrop-blur">
  <div class="flex h-16 items-center justify-between px-5">
    <div>
      <p class="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary dark:text-primary-light">Profile Design</p>
      <h2 class="mt-1 text-lg font-semibold text-content">{pageTitle}</h2>
    </div>
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        onclick={onEnhance}
        disabled={enhancing || saving}
      >
        {enhancing ? 'Enhancing...' : 'Enhance'}
      </button>
      <div class="inline-flex items-center gap-1 rounded-full border border-default bg-surface-tertiary p-1">
        <button
          type="button"
          class="inline-flex h-9 w-9 items-center justify-center rounded-full text-gray-700 dark:text-dark-text-medium transition hover:bg-white dark:hover:bg-dark-elevated disabled:cursor-not-allowed disabled:text-gray-300 dark:disabled:text-gray-600"
          aria-label="Undo"
          title="Undo"
          onclick={onUndo}
          disabled={!canUndo}
        >
          ↶
        </button>
        <button
          type="button"
          class="inline-flex h-9 w-9 items-center justify-center rounded-full text-gray-700 dark:text-dark-text-medium transition hover:bg-white dark:hover:bg-dark-elevated disabled:cursor-not-allowed disabled:text-gray-300 dark:disabled:text-gray-600"
          aria-label="Redo"
          title="Redo"
          onclick={onRedo}
          disabled={!canRedo}
        >
          ↷
        </button>
      </div>
      {#if dirty}
        <span class="rounded-full bg-amber-50 dark:bg-amber-900/30 px-3 py-1 text-xs font-medium text-amber-900 dark:text-amber-300">Unsaved changes</span>
      {/if}
      <button
        type="button"
        class="btn btn-sm bg-violet-700 text-white hover:bg-violet-800 disabled:cursor-not-allowed disabled:bg-gray-300 dark:disabled:bg-gray-600"
        onclick={onSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save'}
      </button>
    </div>
  </div>
</div>
